module.exports = __webpack_public_path__ + "img/38703-017.5981ada9.jpg";